import React from "react";
import { Toast, ToastContainer } from "react-bootstrap";

const SuccessToast = ({
  show,
  message = "Ajout effectue avec succes.",
  onClose,
  delay = 3000,
}) => {
  return (
    <ToastContainer position="top-end" className="position-fixed p-3" style={{ zIndex: 2000 }}>
      <Toast show={show} onClose={onClose} autohide delay={delay} bg="success">
        <Toast.Header closeButton>
          <strong className="me-auto">Succes</strong>
        </Toast.Header>
        <Toast.Body className="text-white">{message}</Toast.Body>
      </Toast>
    </ToastContainer>
  );
};

export default SuccessToast;
